const handleMegaMenu = (resize = false) => {
    if (document.querySelector('.ume-intra-mega-menu')) {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const mainMenu = document.querySelector('.ume-intra-main-menu');
        const navbar = document.querySelector('header .navbar');
        if (resize) {
            navbar.setAttribute('data-hide-top', 'false');
            let toggler = navbar.querySelector('.navbar-toggler');
            if (!toggler.classList.contains('collapsed')) {
                toggler.click();
            }
            let clones = mainMenu.querySelectorAll('.dropdown-toggle-close-clone');
            let activeTargetContainers = mainMenu.querySelectorAll('.ume-intra-mega-menu-target-container-active');
            let activeToggles = mainMenu.querySelectorAll('[aria-expanded="true"]');
            if (activeToggles.length > 0) {
                activeToggles.forEach(tog => {
                    tog.click();
                })
            }
            if (clones.length > 0) {
                clones.forEach(c => {
                    c.remove();
                })
            }
            if (activeTargetContainers.length > 0) {
                activeTargetContainers.forEach(atc => {
                    atc.innerHTML = '';
                    atc.classList.remove('ume-intra-mega-menu-target-container-active')
                })
            }
        }
        if(resize){
            let fakeDropdown = mainMenu.querySelectorAll('.ume-intra-mega-menu-wide-container-fake');
            let fakeParentDropdown = mainMenu.querySelectorAll('.ume-intra-mega-menu-fake');
            if(fakeDropdown.length > 0){
                fakeDropdown.forEach(d => {
                    d.classList.remove('ume-intra-mega-menu-wide-container')
                    d.classList.remove('ume-intra-mega-menu-wide-container-fake')
                })
            }
            if(fakeParentDropdown.length > 0){
                fakeParentDropdown.forEach(d => {
                    d.classList.remove('ume-intra-mega-menu-fake')
                    d.classList.remove('ume-intra-mega-menu')
                })
            }
        }
        if (mainMenu !== null && !mainMenu.querySelector('.dropdown-toggle-close-clone')) {
            let parentDropdownLinks = mainMenu.querySelectorAll('.nav-link.dropdown-toggle');
            if (parentDropdownLinks.length > 0) {
                parentDropdownLinks.forEach(l => {
                    let dropdown = l.nextElementSibling;
                    let linkClone = document.createElement('button');
                    linkClone.classList.add('btn');
                    linkClone.classList.add('btn-link');
                    linkClone.setAttribute('aria-label', `close ${l.innerText}`)
                    linkClone.innerHTML = l.innerHTML;
                    linkClone.classList.add('dropdown-toggle-close-clone');
                    linkClone.classList.add('dropdown-toggle-close-clone-parent');
                    linkClone.classList.add('d-lg-none');
                    dropdown.insertBefore(linkClone, dropdown.firstChild);
                    if (vw < 1181){
                        if(!dropdown.classList.contains('ume-intra-mega-menu-wide-container')){
                            dropdown.classList.add('ume-intra-mega-menu-wide-container');
                            dropdown.classList.add('ume-intra-mega-menu-wide-container-fake');
                            let dropdownParent = dropdown.closest('.menu-item-has-children')
                            if(dropdownParent !== null && !dropdownParent.classList.contains('ume-intra-mega-menu')){
                                dropdownParent.classList.add('ume-intra-mega-menu');
                                dropdownParent.classList.add('ume-intra-mega-menu-fake');
                            }
                        }

                    }
                });
            }
        }

        if (!resize) {
            mainMenu.addEventListener('show.bs.dropdown', ev =>{
                if(ev.target.closest('.ume-intra-mega-menu')){
                    if(vw > 1180){
                        const trigger = ev.target.closest('.ume-intra-mega-menu');
                        const holder = trigger.querySelector('.ume-intra-mega-menu-source-container');
                        if(holder !== undefined && holder !== null){
                            let activeLink = holder.querySelector('.ume-intra-mega-dropdown-toggle.active');
                            if(activeLink !== null){
                                activeLink.click();
                            }
                            if(activeLink === null){
                                let firstLink = holder.querySelector('.ume-intra-mega-dropdown-toggle');
                                if(firstLink !== null){
                                    firstLink.click();
                                }
                            }

                        }
                    }
                    if (vw < 1181 ) {
                        if (navbar.getAttribute('data-hide-top') === 'false') {
                            navbar.setAttribute('data-hide-top', 'true');
                        }
                    }
                }
            })
            mainMenu.addEventListener('hidden.bs.dropdown', ev =>{
                if(ev.target.closest('.ume-intra-mega-menu')){

                    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                    let activeSubSubMenus = navbar.querySelectorAll('.ume-intra-mega-menu-target-container-active');
                    let activeExpanded = navbar.querySelectorAll('.ume-intra-mega-dropdown-toggle[aria-expanded="true"]');
                    if(activeSubSubMenus.length > 0){
                        activeSubSubMenus.forEach(sub => {
                            sub.classList.remove('ume-intra-mega-menu-target-container-active');
                            sub.innerHTML = '';
                        })
                    }
                    if(activeExpanded.length > 0){
                        activeExpanded.forEach(exp =>{
                            exp.setAttribute('aria-expanded', 'false');
                        })
                    }
                    if (vw < 1181 ) {
                        if (navbar.getAttribute('data-hide-top') === 'true') {
                            navbar.setAttribute('data-hide-top', 'false');
                        }
                    }
                }
            });
            document.addEventListener('keydown', ev => {
                let active = document.activeElement;
                if(!active.closest('.ume-intra-mega-menu-source-container')) return;
                if(active.closest('.ume-intra-mega-menu-target-container-fake')) return;
                let megaMenu = active.closest('.ume-intra-mega-menu-source-container');
                if(vw < 1181) return;
                if (ev.key == "ArrowLeft") {
                    if(active.closest('.ume-intra-mega-dropdown-toggle')) return;
                    if(active.closest('.ume-intra-mega-menu-wrapper')){
                        ev.preventDefault();
                        let activeSideDropdown = megaMenu.querySelector('.ume-intra-mega-menu-dropdown:has([aria-expanded="true"])');
                        let activeToggle = activeSideDropdown?.querySelector('.ume-intra-mega-dropdown-toggle[aria-expanded="true"]');
                        activeToggle.focus();
                    }

                } else if (ev.key == "ArrowRight") {
                    if(!active.closest('.ume-intra-mega-dropdown-toggle[aria-expanded="true"]'));
                    ev.preventDefault();
                    let activeTargetContainer = megaMenu.querySelector('.ume-intra-mega-menu-target-container-active');
                    let firstTargetLink = activeTargetContainer?.querySelector('.dropdown-item ');
                    firstTargetLink.focus();
                }
            } )
            document.addEventListener('click', ev => {
                if (ev.target.closest('.ume-intra-mega-dropdown-toggle')) {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    const link = ev.target.closest('.ume-intra-mega-dropdown-toggle');
                    let expanded = link.getAttribute('aria-expanded');
                    let external = link.getAttribute('data-external-close');
                    if(expanded === 'true' && external !== 'true' && vw > 1180){
                        return;
                    }
                    link.setAttribute('data-external-close', '');
                    let holderParent = link.closest('.ume-intra-mega-menu-dropdown');
                    let targetParent = null;
                    if (holderParent !== null) {
                        targetParent = holderParent.nextElementSibling;
                    }
                    if (holderParent === null) {
                        targetParent = link.closest('.ume-intra-mega-menu-target-container');
                        holderParent = targetParent.previousElementSibling;
                    }
                    if(holderParent !== null){
                        let activeToggles = holderParent.querySelectorAll('.ume-intra-mega-dropdown-toggle[aria-expanded="true"]');
                        if(activeToggles.length > 0){
                            activeToggles.forEach(to =>{
                                if(to !== link){
                                    to.setAttribute('data-external-close', 'true');
                                    to.click();
                                }
                            })
                        }
                    }
                    const submenu = link.nextElementSibling;
                    const submenuList = submenu.querySelector('.ume-intra-mega-menu-wrapper');


                    targetParent.innerHTML = '';
                    if (expanded == 'false') {
                        const clone = submenuList.cloneNode(true);
                        link.setAttribute('aria-expanded', 'true');
                        let linkClone = document.createElement('button');
                        linkClone.classList.add('btn');
                        linkClone.classList.add('btn-link');
                        linkClone.setAttribute('aria-label', `close ${link.innerText}`)
                        linkClone.innerHTML = link.innerHTML;
                        linkClone.classList.add('dropdown-toggle-close-clone');
                        clone.style.display = 'block';
                        clone.style.position = 'relative';
                        clone.classList.remove('container');

                        if (vw < 1181) {

                            targetParent.appendChild(linkClone);
                        }

                        targetParent.appendChild(clone);
                        targetParent.classList.add('ume-intra-mega-menu-target-container-active')
                        let firstLink = targetParent.querySelector('.dropdown-item');
                        firstLink.focus();

                    }
                    if (expanded == 'true') {
                        targetParent.classList.remove('ume-intra-mega-menu-target-container-active');
                        let expanded = holderParent.querySelectorAll('[aria-expanded="true"]');
                        if (expanded.length > 0) {
                            expanded.forEach(ex => {
                                ex.setAttribute('aria-expanded', 'false');
                            })
                        }
                    }
                }
                if (ev.target.closest('.dropdown-toggle-close-clone:not(.dropdown-toggle-close-clone-parent)')) {
                    let button = ev.target.closest('.dropdown-toggle-close-clone');
                    let buttonHolder = button.parentElement;
                    let originalToggleHolder = buttonHolder.previousElementSibling;
                    let originalToggle = originalToggleHolder.querySelector('[aria-expanded="true"]')
                    originalToggle.click();
                }
                if (ev.target.closest('.dropdown-toggle-close-clone-parent')) {
                    let button = ev.target.closest('.dropdown-toggle-close-clone-parent');
                    let buttonHolder = button.parentElement;
                    let originalToggle = buttonHolder.previousElementSibling;
                    originalToggle.click();
                }
                if (ev.target.closest('.nav-link.dropdown-toggle')) {


                }
                if (ev.target.closest('a.dropdown-item:not(.ume-intra-mega-dropdown-toggle)')) {

                    let parent = ev.target.closest('.ume-intra-mega-menu.current-menu-ancestor');
                    let parentLink = parent.querySelector('a.nav-link.active.dropdown-toggle.show');
                    if(parentLink !== null){
                        parentLink.click();
                    }

                }
                return;

            })
        }

    }
}
export default handleMegaMenu;